import React from "react";
import { Tab, Row, Col, ListGroup } from "react-bootstrap";

//Components
import Top_bar from "../../Components/topBar/topBar";
import BottomBar from "../../Components/bottomBar/bottomBar";
import Alert from "../../Components/alert/Alert";
import Users from "../Reports/reportUsers";
import { DrawerMenu } from "../../Components/DrawerMenu/DrawerMenu";

//Functions
import { handleColor } from "../../services/Functions";
import AddUser from "../Registration/Users/addUser";
import AltUser from "../Registration/Users/altUser";
import DelUser from "../Registration/Users/delUser";

//Styles
import "./prelude.css";

const prelude_users = () => {
  const [activeTab, setActiveTab] = React.useState("list");
  return (
    <>
      <header>
        <Top_bar />{" "}
      </header>
      <div className="prelude_container">
        <DrawerMenu>
          <Sidebar
            isMobile
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          ></Sidebar>
        </DrawerMenu>
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab}></Sidebar>
      </div>
      <BottomBar></BottomBar>
    </>
  );
};

class Sidebar extends React.Component {
  state = { render: false, message: "", click: false };

  async componentWillMount() {
    let viewport = document.querySelector("meta[name=viewport]");
    viewport.setAttribute(
      "content",
      viewport.content + ", height=" + window.innerHeight
    );
  }

  handleClick = () => {
    if (this.props.click === false) {
      this.setState({ click: true });
      return true;
    } else {
      this.setState({ click: false });
      return false;
    }
  };

  render() {
    const { show, message } = this.state;
    const items = [
      { id: "lg1", label: "Usuários", eventKey: "list" },
      { id: "lg2", label: "Adicionar Usuários", eventKey: "add" },
      { id: "lg3", label: "Alterar Usuários", eventKey: "alt" },
      { id: "lg4", label: "Deletar Usuários", eventKey: "del" },
    ];

    return (
      <Tab.Container activeKey={this.props.activeTab}>
        <Row style={{ width: "100%", height: "100%" }}>
          <div className="sidebar1 ">
            <div
              className={this.props.isMobile ? "sidebar2-mobile" : "sidebar2"}
            >
              <Col className="sidebarColumn" mountOnEnter unmountOnExit>
                <ListGroup>
                  {items.map((item) =>
                    this.props.isMobile ? (
                      <Col key={item.id} xs={12}>
                        <ListGroup.Item
                          id={item.id}
                          onClick={() => {
                            this.props.setActiveTab(item.eventKey);
                            this.props.handleClose();
                          }}
                          className="listGroup"
                          eventKey={item.eventKey}
                        >
                          {item.label}
                        </ListGroup.Item>
                      </Col>
                    ) : (
                      <ListGroup.Item
                        key={item.id}
                        id={item.id}
                        onClick={() => {
                          this.props.setActiveTab(item.eventKey);
                        }}
                        className="listGroup d-none d-md-block"
                        eventKey={item.eventKey}
                      >
                        {item.label}
                      </ListGroup.Item>
                    )
                  )}
                </ListGroup>
              </Col>
            </div>
            <Col
              className="col3"
              style={{
                top: "5%",
                marginLeft: "1.5%",
                height: "100%",
                width: "100%",
                overflow: "auto",
              }}
            >
              {show ? (
                <Alert
                  show={show}
                  message={message}
                  parentCallback={this.callbackfunction}
                />
              ) : null}
              {!this.props.isMobile && (
                <Tab.Content style={{ height: "100%" }}>
                  <Tab.Pane eventKey="list" style={{ height: "100%" }}>
                    {this.handleClick ? <Users /> : null}
                  </Tab.Pane>
                  <Tab.Pane mountOnEnter unmountOnExit eventKey="add">
                    {this.handleClick ? <AddUser /> : null}
                  </Tab.Pane>
                  <Tab.Pane mountOnEnter unmountOnExit eventKey="alt">
                    {this.handleClick ? <AltUser /> : null}
                  </Tab.Pane>
                  <Tab.Pane mountOnEnter unmountOnExit eventKey="del">
                    {this.handleClick ? <DelUser /> : null}
                  </Tab.Pane>
                </Tab.Content>
              )}
            </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}

export default prelude_users;
